/// <reference types="@angular/localize" />

import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './env/environment';
import { ENV_CONFIG, VER_CONFIG } from './app/core/injection.token';
import { TenantServiceConfigurationModel } from './app/models/tenant-service-configuration-model';
import { ENV_PROP_NAMES, TENANT_THEME_KEY } from './app/extensions/constants/commonConstants';

Promise.all([
  fetch('/assets/config/env.json').then(response => response.json()),
  fetch('/assets/ver/ver.json').then(response => response.json()),
])
  .then(async ([envConfig, versionConfig]) => {
    let envData = envConfig as env.EnvConfigurationData;
    let applicationId: string;
    let tenantId: string;

    const tenantUrl = envData.TENANT_BACKEND_APISYNC_URL.replace('/tap', '');

    await fetch(`${tenantUrl}/application/getApplicationId?code=${envData.APP_CODE}`)
      .then(res => res.text())
      .then(async resAppId => {
        applicationId = resAppId;

        await fetch(`${tenantUrl}/tenant/getTenantId`)
          .then(res => res.text())
          .then(async resTenantId => {
            tenantId = resTenantId;

            const headers: HeadersInit = new Headers();
            headers.append('appId', applicationId);
            headers.append('workspace', tenantId);

            localStorage.setItem('appId', applicationId);
            localStorage.setItem('tenantId', tenantId);

            const requestInit: RequestInit = {
              headers: headers,
            };

            const tenantPromises: Promise<Response>[] = [
              fetch(
                `${tenantUrl}/tenant/getTenantServiceConfigurations?serviceCode=${envData.SERVICE_CODE}`,
                requestInit
              ),
            ];

            const tenantTheme = localStorage.getItem(TENANT_THEME_KEY);
            const shouldFetchTheme = tenantTheme == null;
            if (shouldFetchTheme) {
              tenantPromises.push(fetch(`${tenantUrl}/tap/tenant/getTenantTheme`, requestInit));
            }

            const responses = await Promise.all(tenantPromises);

            const serviceConfigResponse = responses[0];
            let tenantServiceConfigurations = [] as TenantServiceConfigurationModel[];
            if (serviceConfigResponse && serviceConfigResponse.ok) {
              tenantServiceConfigurations = (await serviceConfigResponse.json()) as TenantServiceConfigurationModel[];
            }

            if (shouldFetchTheme && responses[1]) {
              const themeResponse = responses[1];
              if (themeResponse && themeResponse.ok) {
                const tenantThemeContent = await themeResponse.text();
                if (tenantThemeContent) {
                  localStorage.setItem(TENANT_THEME_KEY, tenantThemeContent);
                }
              } else {
                localStorage.setItem(TENANT_THEME_KEY, null);
              }
            }

            let customTenantEnv: any = {};
            if (tenantServiceConfigurations.some(x => x)) {
              tenantServiceConfigurations.forEach(item => {
                customTenantEnv[item.configurationKey] = item.configurationValue;
              });
            }
            envData = { ...envData, ...customTenantEnv };

            envData[ENV_PROP_NAMES.REDIRECT_URI] = window.location.origin;
            envData[ENV_PROP_NAMES.POST_LOGOUT_REDIRECT_URI] = window.location.origin;
          });
      });

    return [envData, versionConfig];
  })
  .then(([envConfig, versionConfig]) => {
    if (environment.production) {
      enableProdMode();
    }

    let providers = [
      { provide: ENV_CONFIG, useValue: envConfig },
      { provide: VER_CONFIG, useValue: versionConfig },
    ];

    platformBrowserDynamic(providers)
      .bootstrapModule(AppModule, [
        {
          defaultEncapsulation: ViewEncapsulation.Emulated,
        },
      ])
      .catch(err => console.error(err));
  });
